import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { m } from 'framer-motion';
import Buttons from '../../Components/Button/Buttons';
import { fadeIn } from '../../Functions/GlobalAnimations';
import axios from 'axios';
import config from '../../config';
import { ToastContainer, toast } from 'react-toastify';

const Checkout = (props) => {
  const [user, setUser] = useState(null);
  const [basket, setBasket] = useState([]);
  const [order, setOrder] = useState('');
  const [loading, setLoading] = useState(true);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(localStorage.getItem('uploadedFile') || '');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('accessToken');
      if (!token) {
        toast.error('Veuillez vous connecter pour accéder au checkout');
        navigate('/login-register');
        return;
      }

      try {
        const userResponse = await axios.get(`${config.REACT_APP_API_URL}/user-profile`, {
          headers: { Authorization: `Bearer ${token}`,
            'x-api-key': config.SITE_API_KEY },
        });
        setUser(userResponse.data);

        const basketResponse = await axios.get(`${config.REACT_APP_API_URL}/get-basket`, {
          headers: { Authorization: `Bearer ${token}`,
            'x-api-key': config.SITE_API_KEY },
        });
        setBasket(basketResponse.data.basket);

        if (basketResponse.data.basket.length === 0) {
          toast.error('Votre panier est vide');
          setTimeout(() => navigate('/shopping-cart'), 2000);
          return;
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Erreur lors de la récupération des données');
        setTimeout(() => navigate('/shopping-cart'), 2000);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  const handleCheckout = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      toast.error('Veuillez vous connecter pour finaliser le checkout');
      navigate('/login-register');
      return;
    }
    setIsRedirecting(true);

    try {
      const checkoutResponse = await axios.post(
        `${config.REACT_APP_API_URL}/checkout`,
        { userId: user._id, file: uploadedFile },
        { headers: { Authorization: `Bearer ${token}`, 'x-api-key': config.SITE_API_KEY } }
      );
        setOrder(checkoutResponse.data.order);
        localStorage.removeItem('uploadedFile'); // Clear after successful checkout
        toast.success('Commande effectuée avec succès');
        setTimeout(() => navigate('/dashboard'), 2000);
    } catch (error) {
      setIsRedirecting(false);
      toast.error(error.response?.data?.message || 'Erreur lors du checkout');
    }
  };

  if (loading) {
    return (
      <div style={props.style}>
        <section className="pt-[250px] page-title-small p-[130px] pb-10 lg:px-0 xs:px-0">
          <Container>
            <Row className="items-center justify-center">
              <Col xl={8} lg={6}>
                <h1 className="font-serif text-lg text-black font-medium mb-0 md:text-center">Checkout</h1>
              </Col>
            </Row>
          </Container>
        </section>
        <m.section className="pb-[130px] lg:pb-[90px] md:pb-[75px] sm:pb-[50px]" {...fadeIn}>
          <Container>
            <Row>
              <Col>Chargement...</Col>
            </Row>
          </Container>
        </m.section>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  const totalStories = basket.length;

  return (
    <div className="bg-[#fbfbfb] checkout-page" style={props.style}>
      <section className="pt-[250px] page-title-small p-[130px] pb-10 lg:px-0 xs:px-0">
        <Container>
          <Row className="items-center justify-center">
            <Col xl={8} lg={6}>
              <h1 className="font-serif text-lg text-black font-medium mb-0 md:text-center">Checkout</h1>
            </Col>
            <Col xl={4} lg={6} className="breadcrumb justify-end text-sm font-serif mb-0 md:mt-[10px] md:justify-center">
              
            </Col>
          </Row>
        </Container>
      </section>

      <m.section className="pb-[130px] lg:pb-[90px] md:pb-[75px] sm:pb-[50px]" {...fadeIn}>
        <Container>
          <Row>
            <Col lg={7} md={6} className="pr-[70px] lg:pr-[40px] md:pr-[15px]">
              <div className="p-16 border border-mediumgray lg:mt-[35px] md:p-10">
                <h2 className="flex text-black text-start text-[20px] leading-[65px] tracking-[-1px] sm:leading-[50px] sm:mb-[25px]">
                  Informations de l'utilisateur
                </h2>
                <div className="grid gap-6 mb-6 grid-cols-2">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray">Raison Sociale:</label>
                    <input
                      type="text"
                      value={user.company_name || ''}
                      readOnly
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray">Matricule Fiscal:</label>
                    <input
                      type="text"
                      value={user.tax_registre || ''}
                      readOnly
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray">Numéro de téléphone:</label>
                    <input
                      type="tel"
                      value={user.phone || ''}
                      readOnly
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray">Adresse:</label>
                    <input
                      type="text"
                      value={[
    user?.adresse?.adresse,
    user?.adresse?.Gouvernorat
  ].filter(Boolean).length > 0
    ? [
        user?.adresse?.adresse,
        user?.adresse?.Gouvernorat
      ]
        .filter(Boolean)
        .join(', ')
    : <span>__________</span>}
                      readOnly
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                    />
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={5} md={6}>
              <div className="bg-lightgray p-[45px] lg:p-[30px] sm:p-[20px]">
                <span className="font-serif text-lg md:text-xmd text-darkgray mb-[25px] inline-block font-medium">Résumé de la commande</span>
                <table>
                  <tbody>
                      <tr className="total-amount flex flex-row w-[250px]">
                        <td className="font-medium text-darkgray py-[20px]">Produits total :</td>
                        <td className="py-[20px]">
                          <h6 className="block font-medium mb-0 pl-2 text-darkgray">{totalStories} Produits </h6>
                        </td>
                      </tr>
                    {uploadedFile && (
                      <tr className="total-amount flex flex-row w-[800px]">
                        <td className="font-medium text-darkgray py-[20px]">Fichier téléchargé :</td>
                        <td className="py-[20px]">
                          <p className="block font-medium mb-0 pl-2 text-darkgray">{uploadedFile.substr(0, 50) + " ...."}</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {isRedirecting ? (
                  <p className="text-center">Redirection vers le dashboard...</p>
                ) : order ? (
                  <p className="text-sm mb-[25px] xs:mb-[15px]">
                    Votre commande a été enregistrée avec succès.{' '}
                    <Link className="text-decoration-underline hover:text-fastblue" to="/dashboard">Retourner au tableau de bord</Link>.
                  </p>
                ) : (
                  <div className="mt-[20px]">
                    <Buttons
                      onClick={handleCheckout}
                      className="btn-fill tracking-[1px] font-medium font-serif rounded-none uppercase md:mb-[15px] !py-[13px] block w-full"
                      themeColor="#558927"
                      color="#fff"
                      size="lg"
                      title="Commander"
                    />
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
        <ToastContainer position="bottom-left" />
      </m.section>
    </div>
  );
};

export default Checkout;